module.exports = __webpack_public_path__ + "04_mustache_brown.0c38b5d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/papa/layer3/04_mustache_brown.png
// module id = TBu3
// module chunks = 0